import { create } from 'zustand';
import { ApiUtils, FileApi, FileTypeEntity, RequestStrategyEnum } from '@shared/api';

interface UseFileTypesStore {
  loading: boolean;
  data: FileTypeEntity[];
  error: string | null;
  getFileTypes: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useFileTypesStore = create<UseFileTypesStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getFileTypes: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await FileApi.getFileTypes(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
